import apiService from '../apiService';

/**
 * 取得付款方式列表
 * @param {Object} params - 查詢參數
 * @param {number} params.page - 頁碼
 * @param {number} params.per_page - 每頁筆數（預設：15）
 * @param {number} params.status - 狀態篩選（0=停用, 1=啟用）
 * @param {string} params.keyword - 關鍵字搜尋（代碼或名稱）
 * @returns {Promise} API 響應
 */
export const getPaymentMethods = async (params = {}) => {
    const url = '/api/admin/payment-methods';
    return apiService.GET(url, params);
};

/**
 * 取得單一付款方式詳情
 * @param {number} id - 付款方式 ID
 * @returns {Promise} API 響應
 */
export const getPaymentMethodDetail = async (id) => {
    const url = `/api/admin/payment-methods/${id}`;
    return apiService.GET(url);
};

/**
 * 新增付款方式
 * @param {Object} data - 付款方式資料
 * @param {string} data.code - 付款方式代碼（唯一，最大長度：50）
 * @param {string} data.name - 付款方式名稱（最大長度：100）
 * @param {number} data.status - 狀態（1=啟用, 0=停用，預設：1）
 * @returns {Promise} API 響應
 */
export const createPaymentMethod = async (data) => {
    const url = '/api/admin/payment-methods';
    return apiService.POST(url, data);
};

/**
 * 更新付款方式
 * @param {number} id - 付款方式 ID
 * @param {Object} data - 更新資料
 * @param {string} data.code - 付款方式代碼（最大長度：50）
 * @param {string} data.name - 付款方式名稱（最大長度：100）
 * @param {number} data.status - 狀態（1=啟用, 0=停用）
 * @returns {Promise} API 響應
 */
export const updatePaymentMethod = async (id, data) => {
    const url = `/api/admin/payment-methods/${id}`;
    return apiService.PUT(url, data);
};

/**
 * 刪除付款方式
 * @param {number} id - 付款方式 ID
 * @returns {Promise} API 響應
 */
export const deletePaymentMethod = async (id) => {
    const url = `/api/admin/payment-methods/${id}`;
    return apiService.DELETE(url);
};
